export const messages = {
  en: {
    productSj: {
      search: {
        title: 'Search Conditions',
        prodName: 'Please enter product name'
      },
      list: {
        title: 'Shelved Products',
        today: 'Today',
        all: 'All Shelved'
      },
      table: {
        productId: 'Product ID',
        coverPhoto: 'Product Image',
        categoryName: 'Product Category',
        prodName: 'Product Name',
        sales: 'Sales',
        stock: 'Stock',
        price: 'Price',
        sort: 'Sort',
        state: 'Status'
      },
      fetchError: 'Failed to fetch product list'
    }
  },
  zh: {
    productSj: {
      search: {
        title: '查询条件',
        prodName: '请输入商品名称'
      },
      list: {
        title: '上架商品',
        today: '今日上架',
        all: '所有上架'
      },
      table: {
        productId: '商品ID',
        coverPhoto: '商品图片',
        categoryName: '商品分组',
        prodName: '商品名称',
        sales: '销量',
        stock: '库存',
        price: '价格',
        sort: '排序',
        state: '状态'
      },
fetchError: '获取商品列表失败'
    }
  },
  'zh-TW': {
    productSj: {
      search: {
        title: '查詢條件',
        prodName: '請輸入商品名稱'
      },
      list: {
        title: '上架商品',
        today: '今日上架',
        all: '所有上架'
      },
      table: {
        productId: '商品ID',
        coverPhoto: '商品圖片',
        categoryName: '商品分組',
        prodName: '商品名稱',
        sales: '銷量',
        stock: '庫存',
        price: '價格',
        sort: '排序',
        state: '狀態'
      },
      fetchError: '獲取商品列表失敗'
    }
  }
}